import { Component, OnInit, Input, OnDestroy, ViewChildren, Renderer, ViewEncapsulation, ViewChild } from '@angular/core';
import { Speaker } from '../models/speaker';
import { IterateObjectPipe } from '../iterate-object.pipe';
import { SpeakerService } from '../speaker.service';

import { Subscription } from 'rxjs/Subscription';

import {DataTable} from 'primeng/components/datatable/datatable';

@Component({
	selector: 'concordance',
	templateUrl: './concordance.component.html',
	styleUrls: ['./concordance.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class ConcordanceComponent implements OnInit, OnDestroy {
	
	@Input() instances: any[];
	@ViewChildren('cbx') checkboxes;
	@ViewChild('dt') dt: DataTable;
	
	selected = [];
	speaker_ids = [];
	
	name: boolean = false;
	age: boolean = false;
	gender: boolean = false;
	social: boolean = false;
	region: boolean = false;
	corpus: boolean = false;
	
	
	concordanceGenderFilterSubscription: Subscription;
	concordanceClassFilterSubscription: Subscription;
	concordanceAgeFilterSubscription: Subscription;
	concordanceClearFilterSubscription: Subscription;
	concordanceCorpusFilterSubscription: Subscription;
	concordanceMapFilterSubscription: Subscription;
	concordanceCount = 10;
	
	constructor(private speaker: SpeakerService, private renderer: Renderer) {
		let self: ConcordanceComponent = this;
		speaker.instanceChange.subscribe((res) => {
			self.updateConcordanceCount({});
		});
	}
	
	ngOnInit() {
		let self: ConcordanceComponent = this;
		this.updateConcordanceCount({});
		this.concordanceGenderFilterSubscription = this.speaker.concordanceGenderFilter.subscribe(event => {
			if (event.element) {
				this.speaker.concordanceClearFilter.next({});
				setTimeout(() => {
					self.dt.filter(event.element._model.datasetLabel, 'speaker.BNC subset', 'equals');
					self.dt.filter(event.element._model.label.toLowerCase(), 'speaker.gender', 'equals');
					self.corpus = true;
					self.gender = true;
				}, 100);
				self.speaker.concordanceGenderFilter.next({});
			}
		});
		this.concordanceClassFilterSubscription = this.speaker.concordanceClassFilter.subscribe(event => {
			if (event.element) {
				this.speaker.concordanceClearFilter.next({});
				setTimeout(() => {
					self.dt.filter(event.element._model.datasetLabel, 'speaker.BNC subset', 'equals');
					self.dt.filter(event.element._model.label.toLowerCase(), 'speaker.social class', 'equals');
					self.corpus = true;
					self.social = true;
				}, 100);
				self.speaker.concordanceClassFilter.next({});
			}
		});
		this.concordanceAgeFilterSubscription = this.speaker.concordanceAgeFilter.subscribe(event => {
			if (event.point) {
				this.speaker.concordanceClearFilter.next({});
				setTimeout(() => {
					self.dt.filter(event.point.name, 'speaker.name_new', 'equals');
					self.name = true;
				}, 100);
				self.speaker.concordanceAgeFilter.next({});
			}
		});
		this.concordanceCorpusFilterSubscription = this.speaker.concordanceCorpusFilter.subscribe(event => {
			if (event.element) {
				this.speaker.concordanceClearFilter.next({});
				setTimeout(() => {
					self.dt.filter(event.element._model.datasetLabel, 'speaker.BNC subset', 'equals');
					self.corpus = true;
				}, 100);
				self.speaker.concordanceClassFilter.next({});
			}
		});
		this.concordanceMapFilterSubscription = this.speaker.concordanceMapFilter.subscribe(event => {
			if (event.corpus) {
				this.speaker.concordanceClearFilter.next({});
				setTimeout(() => {
					self.dt.filter(event.corpus, 'speaker.BNC subset', 'equals');
					self.dt.filter(event.region, 'speaker.area', 'equals');
					self.corpus = true;
					self.region = true;
				}, 100);
				self.speaker.concordanceMapFilter.next({});
			}
		});
		this.concordanceClearFilterSubscription = this.speaker.concordanceClearFilter.subscribe(event => {
			setTimeout(() => {
				self.name = false;
				self.corpus = false;
				self.social = false;
				self.gender = false;
				self.region = false;
				self.dt.reset();
				self.dt.filter('', 'speaker.BNC subset', 'equals');
				self.dt.filter('', 'speaker.social class', 'equals');
				self.dt.filter('', 'speaker.gender', 'equals');
				self.dt.filter('', 'speaker.name_new', 'equals');
				self.dt.filter('', 'speaker.area', 'equals');
			}, 30);
		});
	}
	
	ngOnDestroy() {
		if (this.concordanceGenderFilterSubscription)
			this.concordanceGenderFilterSubscription.unsubscribe();
		if (this.concordanceClassFilterSubscription)
			this.concordanceClassFilterSubscription.unsubscribe();
		if (this.concordanceAgeFilterSubscription)
			this.concordanceAgeFilterSubscription.unsubscribe();
		if (this.concordanceClearFilterSubscription)
			this.concordanceClearFilterSubscription.unsubscribe();
		if (this.concordanceMapFilterSubscription)
			this.concordanceMapFilterSubscription.unsubscribe();
		if (this.concordanceCorpusFilterSubscription)
			this.concordanceCorpusFilterSubscription.unsubscribe();
	}
	/*
	  ngOnChanges() {
	  }
	*/
	switchInstance(event) {
		// this.speaker.switchInstance(this.cTable.first, event.data, event.originalEvent.checked);
	}
	
	switchInstances(event) {
		// this.speaker.switchInstances(event.checked);
	}
	
	exportCSV(dt) {
		let originalConc = [];
		let self = this;
		dt.value.forEach(row => {
			originalConc.push({r: row.concordance, left: row.concordance.leftDisplay, right: row.concordance.rightDisplay});
			row.concordance.leftDisplay = self.stripHTML(row.concordance.leftDisplay);
			row.concordance.rightDisplay = self.stripHTML(row.concordance.rightDisplay);
		});
		
		dt.exportCSV();
		
		originalConc.forEach(conc => {
			conc.r.leftDisplay = conc.left;
			conc.r.rightDisplay = conc.right;
		});
	}
	
	stripHTML(s: string) {
		let str = "";
		let insideTag = false;
		for (let i = 0; i < s.length; i++) {
			if (s.charAt(i) == '<')
				insideTag = true;
			
			if (s.charAt(i) == '>') {
				insideTag = false;
				continue;
			}
			
			if (!insideTag)
				str += s.charAt(i);
		}
		return str;
	}
	
	updateConcordanceCount(event) {
		this.speaker.instances.map(inst => {
			let left = inst['concordance']['left'],
				right = inst['concordance']['right'];
			let leftRemvl = left.length - this.concordanceCount;
			if (leftRemvl >= 0) {
				inst['concordance']['leftDisplay'] = this.buildDisplay(left.slice(left.length - this.concordanceCount), true);
			} else {
				inst['concordance']['leftDisplay'] = this.buildDisplay(left, true);
			}
			inst['concordance']['rightDisplay'] = this.buildDisplay(right.slice(0 , this.concordanceCount), false);
		});
	}
	
	printSpeaker(event) {
		console.log(event);
	}
	
	buildDisplay(concArray, isLHS) {
		if (concArray.length == 0) {
			return "";
		}
		let display = "";
		let isTarget;
		if (isLHS)
			isTarget = concArray[0].type == "ntrgt" ? true : false;
		else
			isTarget = concArray[0].type == "ntrgt" ? false : true;
		for (let i = 0; i < concArray.length; i++) {
			if (concArray[i].type == "ntrgt") {
				if (isTarget) {
					if (this.concordanceCount != 100 && i == 0)
						display += "<font color='blue'>" + concArray[i].ele + "</font> ";
					else
						display += "<font color='blue'>S: " + concArray[i].ele + "</font> ";
					isTarget = false;
				} else if (!isLHS && i == 0) {
					display += "<font color='blue'>S: " + concArray[i].ele + "</font> ";
				} else {
					display += "<font color='blue'>" + concArray[i].ele + "</font> ";
				}
			} else if (concArray[i].type == "trgt") {
				if (isTarget) {
					display += "<font color='black'>" + concArray[i].ele + "</font> ";
				} else if (this.concordanceCount != 100 && i == 0) {
					display += "<font color='black'>" + concArray[i].ele + "</font> ";
				} else {
					display += "<font color='black'>S: " + concArray[i].ele + "</font> ";
					isTarget = true;
				}
			}
		}
		return display.substring(0, display.length - 1);
	}
	
	concordanceSort(event, leftSort) {
		this.speaker.instances = [...this.speaker.instances.sort(function(a, b): number {
			let first;
			let second;
			if (leftSort) {
				first = a.concordance.left;
				second = b.concordance.left;
				let first_i = first.length - 1;
				let second_i = second.length - 1;
				while (first_i > -1 && second_i > -1) {
					let cmp = first[first_i].ele.localeCompare(second[second_i].ele);
					if (cmp < 0) {
						return -1 * event.order;
					} else if (cmp > 0) {
						return 1 * event.order;
					}
					first_i--;
					second_i--;
				}
				if (first_i < second_i) {
					return -1 * event.order;
				} else if (first_i > second_i) {
					return 1 * event.order;
				}
				return 0;
			} else {
				first = a.concordance.right;
				second = b.concordance.right;
				let first_i = 0;
				let second_i = 0;
				while (first_i < first.length && second_i < second.length) {
					let cmp = first[first_i].ele.localeCompare(second[second_i].ele);
					if (cmp < 0) {
						return -1 * event.order;
					} else if (cmp > 0) {
						return 1 * event.order;
					}
					first_i++;
					second_i++;
				}
				if (first.length < second.length) {
					return -1 * event.order;
				} else if (first.length > second.length) {
					return 1 * event.order;
				}
				return 0;
			}
		})];
	}
	
	ageSort(event) {
		this.speaker.instances = [...this.speaker.instances.sort(function(a, b): number {
			let age1 = Number(a.speaker.age);
			let age2 = Number(b.speaker.age);
			if (age1 < age2)
				return event.order * -1;
			else
				return event.order * 1;
		})];
	}
}




// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/concordance/concordance.component.ts